export async function getGeoLocationData() {
  const geoLocationService =
    process.env.GEO_IP_SERVICE_ENDPOINT || 'https://ipapi.co/json/';
  let geoLocationData;

  try {
    const res = await fetch(geoLocationService);
    geoLocationData = await res.json();
  } catch (ex) {
    /*Not Supported by all browsers*/
  }

  return geoLocationData;
}
